import React from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';

export const formatCurrency = (value, showPlaceholder) => {
  if (!value && value !== 0) {
    return `${showPlaceholder ? '--' : ''}`;
  }
  // TODO CONFIG BY LOCALE
  return accounting.formatMoney(value, {
    symbol: '',
    precision: 2,
    thousand: ' ',
    format: {
      pos: '%s%v',
      neg: '-%s%v',
      zero: '%s%v'
    }
  });
};

const Money = ({
  amount,
  amountRangeString,
  currency,
  component,
  showPlaceholder,
  className
}) => {
  const Component = component || Money.defaultProps.component;
  const formattedAmount =
    typeof amount === 'string' ? amount.replace(',', '.') : amount;
  const numberAmount = Number.parseFloat(formattedAmount);

  if (amountRangeString) {
    const amounts = amountRangeString.replace(',', '.').split(' - ');
    const amountFrom = Number.parseFloat(amounts[0]);
    const amountTo = amounts[1] ? Number.parseFloat(amounts[1]) : null;
    if (isNaN(amountFrom)) {
      return <Component className={className}>-</Component>;
    }

    return (
      <Component className={className}>
        {formatCurrency(amountFrom, false)}
        {amountTo && ' - ' + formatCurrency(amountTo, false)}
      </Component>
    );
  }

  return (
    <Component className={className}>
      {formatCurrency(numberAmount, showPlaceholder)}
      {numberAmount ? ' ' + currency.toUpperCase() : ''}
    </Component>
  );
};

Money.defaultProps = {
  component: 'span',
  amount: 0,
  currency: '',
  showPlaceholder: false
};

Money.propTypes = {
  amount: PropTypes.number || PropTypes.string,
  currency: PropTypes.string,
  component: PropTypes.string,
  className: PropTypes.string,
  showColors: PropTypes.bool,
  showPlaceholder: PropTypes.bool
};

export default Money;
